import React from 'react'
import {Layout, Menu, Button, Tooltip} from 'antd'
import {inject, observer} from 'mobx-react'
import auth from '../../utils/auth'
import history from '../../routes/history'
import {MenuFoldOutlined, MenuUnfoldOutlined} from '@ant-design/icons'
import {withRouter} from 'react-router-dom'
import {withTranslation} from 'react-i18next'
import $ from 'jquery'
import * as AppUrl from '../../constants/appUrl'
import iconReportPage from '../../assets/images/nav_reportPage.png'
import iconPBIReportPage from '../../assets/images/nav_powerbiReport.png'

const storage = window.localStorage
const {Sider} = Layout

@inject('accountStore', 'mappingManagementStore', 'reportManagementStore', 'routerStateModel', 'auditLogsStore')
@observer
class AppMenu extends React.Component {
  state = {
    collapsed: false,
    openKeys: [],
    menus: [],
    num: '',
  }

  componentDidMount() {
    const {accountStore, location, reportManagementStore, routerStateModel, match} = this.props
    const {reportMenus} = reportManagementStore
    const breadParams = location.pathname === '/' ? ['home'] : location.pathname.split('/').filter(i => i)
    reportManagementStore.getReportMenu(iconReportPage, iconPBIReportPage, () => {history.push(AppUrl.REPORTPAGE)}, () => {history.push(AppUrl.PBIREPORTPAGE)}).then(res => {
      if (res?.code === 0) {
        const tempReportMenu = res.finaleMenu.filter(item => item.type === '查询语句')
        const tempPbiReportMenu = res.finaleMenu.filter(item => item.type === 'PowerBI')
        if(breadParams.includes('reportPage') && breadParams.length === 1 && tempReportMenu.length > 0) {
          window.location.href = `${AppUrl.REPORTPAGE}/${tempReportMenu[0].key}`
        }
        if(breadParams.includes('pbiReportPage') && breadParams.length === 1 && tempPbiReportMenu.length > 0) {
          window.location.href = `${AppUrl.REPORTPAGE}/${tempPbiReportMenu[0].key}`
        }


        const newMenus = auth.getMenus().map(item => {
          if (item.key === 'reportPage') {
            item.children = res.finaleMenu.filter(item => item.type === '查询语句')
          }
          if (item.key === 'pbiReportPage') {
            item.children = res.finaleMenu.filter(item => item.type === 'PowerBI')
          }
          return item
        })

        this.setState({
          menus: newMenus
        })

        accountStore.getPermissionKeys()
        accountStore.onMenuClick(breadParams)
        
        // 判断当前路径是否为报表相关路径
        const isReportPath = breadParams.includes('reportPage') || breadParams.includes('pbiReportPage') || breadParams.includes('reportManagement') || breadParams.includes('reportTag');
        
        // 如果不是报表相关路径，清除tab列表
        if (!isReportPath) {
          routerStateModel.clearUrlHistory();
          accountStore.setIsTabHas(false);
          // 清除localStorage中的selectedItem，避免影响后续的报表相关操作
          localStorage.removeItem('selectedItem');
        }
        
        if (((breadParams.includes('reportPage') || breadParams.includes('pbiReportPage')) && res.finaleMenu.length > 0) || breadParams.includes('reportManagement') || breadParams.includes('reportTag')) {
          // 优先从URL参数获取reportId
          let reportId = null;
          let reportType = null;
          if (match && match.params && match.params.id) {
            reportId = match.params.id;
            if (window.location.pathname.includes('pbiReportPage')) {
              reportType = 'pbiReportPage';
            } else {
              reportType = 'reportPage';
            }
          } else {
            // 向后兼容：从localStorage获取
            const selectedItem = localStorage.getItem('selectedItem')
            if (selectedItem) {
              const [id, type] = selectedItem.split(',')
              reportId = id;
              reportType = type;
            }
          }
          
          // 如果没有reportType，根据当前路径判断
          if (!reportType) {
            if (breadParams.includes('reportManagement')) {
              reportType = 'reportManagement';
            } else if (breadParams.includes('pbiReportPage')) {
              reportType = 'pbiReportPage';
            } else {
              reportType = 'reportPage';
            }
          }
          
          const reportList = res.finaleMenu?.filter(a => a?.type === '查询语句')
          const pbiReportList = res.finaleMenu?.filter(a => a?.type === 'PowerBI')
          const reportSelected = [breadParams[0] === 'reportPage' ? reportList[0]?.key : pbiReportList[0]?.key, breadParams[0]]
          
          if (reportType === 'reportManagement' || reportType === 'reportTag') {
            this.setState({openKeys: ['reportHardManagement']})
          } else if (reportSelected.length > 1) {
            if (reportType !== breadParams[0]) {
              if (reportType === 'pbiReportPage') {
                history.push(`${AppUrl.PBIREPORTPAGE}/${reportId}`)
                this.setState({openKeys: reportSelected})
              } else {
                history.push(`${AppUrl.REPORTPAGE}/${reportId}`)
                this.setState({openKeys: reportSelected})
              }
            } else {
              this.setState({openKeys: [reportId, reportType]})
            }
          } else {
            if (res.finaleMenu.some(item => item?.type === '查询语句')) {
              const reportLsValue = res.finaleMenu.find(item => item.type === '查询语句')?.key
              accountStore.setSeletedItem(reportLsValue)
              this.setState({openKeys: [reportLsValue, reportSelected[1]]})
            } else if (res.finaleMenu.some(item => item?.type === 'PowerBI')) {
              const reportLsValue = res.finaleMenu.find(item => item.type === 'PowerBI')?.key
              accountStore.setSeletedItem(reportLsValue)
              this.setState({openKeys: [reportLsValue, reportSelected[1]]})
            }
          }
        }
        // } else if (breadParams.includes('reportManagement')) {
        //   // accountStore.setSeletedItem(['reportManagement'])
        //   // accountStore.setReportName('报表管理')
        //   this.setState({openKeys: ['reportManagement']})
        // }
        // accountStore.reportFetchFlagChange()
        if ((breadParams.includes('reportPage') || breadParams.includes('pbiReportPage') || breadParams.includes('reportManagement')) && res.finaleMenu.length === 0) {
          return history.push('/403')
        }

        const menuUlWidth = $('.ant-menu.ant-menu-root').width()
        const num = (210 - menuUlWidth + 210) / 210 * 100
        num.toFixed(0)
        $('.ant-layout-sider .menuDiv').css({width: num.toFixed(0) + '%'})
        console.log(menuUlWidth, num)
        this.setState({
          num: num.toFixed(0) + '%'
        })
        accountStore.onSetSelectItemAction()
      }
    })
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const {reportManagementStore} = this.props
    reportManagementStore.getReportMenu(iconReportPage, iconPBIReportPage, () => {history.push(AppUrl.REPORTPAGE)}).then(res => {
      if (res.code === 0) {
        const newMenus = auth.getMenus().map(item => {
          if (item.key === 'reportPage') {
            item.children = res.finaleMenu.filter(item => item.type === '查询语句')
          }
          if (item.key === 'pbiReportPage') {
            item.children = res.finaleMenu.filter(item => item.type === 'PowerBI')
          }
          return item
        })

        this.setState({
          menus: newMenus
        })
      }
    })
  }

  handleExport = () => {
    const {mappingManagementStore} = this.props
    mappingManagementStore.onExportManualFileAction()
  }

  toggle = () => {
    const {collapsed, num} = this.state
    this.setState({
      collapsed: !collapsed,
    })
    if (collapsed) {
      $('.ant-layout-sider .menuDiv').css({width: num, overflowY: 'scroll', overflowX: 'hidden'})
    } else {
      $('.ant-layout-sider .menuDiv').css({width: '100%', overflow: 'hidden'})
    }

  }

  onOpenChange = openKeys => {
    const {openKeys: openKeysState, menus} = this.state
    const lastOpenKey = openKeys.find(key => openKeysState.indexOf(key) === -1) || ''
    const rootSubMenuKeys = menus.map(m => m.key)
    if (rootSubMenuKeys.indexOf(lastOpenKey) === -1) {
      this.setState({openKeys})
    } else {
      this.setState({
        openKeys: lastOpenKey ? [lastOpenKey] : [],
      })
    }
  }

  onMenuClick = e => {
    const {accountStore, reportManagementStore, routerStateModel, auditLogsStore, match} = this.props
    const {urlHistory} = routerStateModel
    accountStore.onMenuClick([e.key])
    accountStore.setSeletedItem(e.keyPath)
    
    // 判断是否为报表相关菜单
    const isReportMenu = e.keyPath.includes('reportPage') || e.keyPath.includes('pbiReportPage') || e.keyPath.includes('reportManagement') || e.keyPath.includes('reportTag');
    
    // 如果不是报表相关菜单，清除tab列表
    if (!isReportMenu) {
      routerStateModel.clearUrlHistory();
      accountStore.setIsTabHas(false);
      // 清除localStorage中的selectedItem，避免影响后续的报表相关操作
      localStorage.removeItem('selectedItem');
    }
    
    // 判断该菜单是否已经存在于标签中。
    const isTab = urlHistory?.filter(a => a?.id.toString() === e.key)?.length > 0 ? urlHistory?.length === 1 ? false : true : false

    if (e.keyPath.includes('reportPage') || e.keyPath.includes('pbiReportPage')) {
      // 优先从URL参数获取reportId
      let reportId = null;
      if (match && match.params && match.params.id) {
        reportId = match.params.id;
      } else {
        // 向后兼容：从localStorage获取
        const selectedItem = localStorage.getItem('selectedItem');
        if (selectedItem) {
          const reportPageInfo = selectedItem.split(',');
          reportId = reportPageInfo[0];
        }
      }
      
      // 如果没有reportId，直接使用e.key
      if (!reportId) {
        reportId = e.key;
      }
      
      reportManagementStore.getReportDetail(reportId)
        .then(() => {
          const {tabsInfo} = reportManagementStore
          accountStore.setReportName(tabsInfo.name)
          if (e.keyPath.includes('pbiReportPage')) {
            accountStore.setIsTabHas(isTab)
            routerStateModel.addRoute({
              groupKey: tabsInfo.id,
              pathname: '/pbiReportPage',
              id: tabsInfo.id,
              name: tabsInfo.name,
              component: 'PbiReportPage'
            })
            const params = {
              logUrl: tabsInfo.pbiUrl,
              logOperationType: '查询',
              logType: tabsInfo.name + ':可视化报表查询',
            }
            auditLogsStore.insertAuditLog(params)
            // 跳转到带id的URL
            history.push(`${AppUrl.PBIREPORTPAGE}/${tabsInfo.id}`)
          } else {
            accountStore.setIsTabHas(isTab)
            routerStateModel.addRoute({
              groupKey: tabsInfo.id,
              pathname: '/reportPage',
              id: tabsInfo.id,
              name: tabsInfo.name,
              component: 'ReportPage'
            })
            // 跳转到带id的URL
            history.push(`${AppUrl.REPORTPAGE}/${tabsInfo.id}`)
          }
        })
    } else if (e.key === 'reportManagement') {
      accountStore.setReportName('报表管理')
      accountStore.setIsTabHas(isTab)
      routerStateModel.addRoute({
        groupKey: 'reportManagement',
        pathname: '/reportManagement',
        id: 'reportManagement',
        name: '报表管理',
        component: 'ReportManagement'
      })
      history.push(AppUrl.REPORTMANAGEMENT)
    } else if (e.key === 'reportTag') {
      accountStore.setReportName('报表标签')
      accountStore.setIsTabHas(isTab)
      routerStateModel.addRoute({
        groupKey: 'reportTag',
        pathname: '/reportTag',
        id: 'reportTag',
        name: '报表标签',
        component: 'ReportTag'
      })
      history.push(AppUrl.REPORTTAG)
    }
  }

  render() {
    const {accountStore, reportManagementStore, match} = this.props
    const {selectedItem} = accountStore
    const {menus, collapsed, openKeys} = this.state
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    
    // 优先从URL参数获取selectedKeys
    let selectedKeys = [];
    if (match && match.params && match.params.id) {
      selectedKeys = [match.params.id];
    } else if (selectedItem) {
      selectedKeys = [selectedItem.split(',')[0]];
    }
    
    return (
      <Sider
        theme="dark"
        trigger={null}
        collapsible
        collapsed={collapsed}
        id="sider"
        width="210"
        className="leftBar"
        // collapsedWidth="60"
        ref={dom => { this.leftBarDom = dom }}
      >
        <div className="logo">
          <img alt="logo" src={!collapsed ? themeStyle?.logoImage || require('../../assets/images/login-logo3.png') : themeStyle?.logoImageCollapsed || require('../../assets/images/login-logo4.png')}
               onClick={() => {
                 this.onMenuClick({key: 'home', keyPath: ['home']})
                 history.push('/')
               }}/>
        </div>
        <div className="menuDiv">
          <Menu
            mode="inline"
            onOpenChange={this.onOpenChange}
            selectedKeys={selectedKeys}
            openKeys={openKeys}
            onClick={this.onMenuClick}
            items={menus}
            defaultSelectedKeys={['home']}
          />
        </div>
        <Button type="primary" onClick={this.toggle} className="menuToggle">
          {collapsed ? <MenuUnfoldOutlined/> : <MenuFoldOutlined/>}
        </Button>
      </Sider>
    )
  }
}

export default withTranslation()(withRouter(AppMenu))
